import AuthorizationHelper from '@auth/services/authorization.helper';
import AuthorizationService from '@auth/services/authorization.service';

const routes = [
  {
    path: 'disciplines',
    name: 'admin-disciplines',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.disciplines],
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-disciplines" */ '@centers/pages/disciplines/disciplines.vue'
      ),
  },
  {
    path: 'holidays',
    name: 'admin-holidays',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.holidays],
    },
    component: () =>
      import(/* webpackChunkName: "admin-holidays" */ '@centers/pages/holiday/holiday.vue'),
  },
  {
    path: 'periods',
    name: 'admin-periods',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.periods],
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-periods" */ '@centers/pages/period-table/period-table.vue'
      ),
  },
  {
    path: 'resources',
    name: 'admin-resources',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.resources],
    },
    component: () =>
      import(/* webpackChunkName: "admin-contacts" */ '@centers/pages/resources/resources.vue'),
  },
];

export const publicDisciplinesRoutes = [
  {
    path: 'discipline/:alias',
    name: 'public-discipline-details',
    meta: {
      layout: 'bpc-public',
      publicRoute: true,
      entity: 'discipline',
    },
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "public-discipline-details" */ '@centers/pages/singles/discipline/discipline-single.vue'
      ),
  },
];

export const publicResourcesRoutes = [
  {
    path: 'resource/:alias',
    name: 'public-resource-details',
    meta: {
      layout: 'bpc-public',
      publicRoute: true,
      entity: 'resource',
    },
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "public-resource-details" */ '@centers/pages/singles/resource/resource-single.vue'
      ),
  },
];

export default routes;
